<template>
  <div>
    <v-snackbar v-model="snackbar" timeout="3000" right top color="success">
      {{ snackText }}
    </v-snackbar>
    <ApolloQuery :query="require('../api/subscriptions/on_create_customer.gql')" fetchPolicy="no-cache">
      <ApolloSubscribeToMore :document="require('../api/subscriptions/on_create_customer.gql')" :updateQuery="onCreateCustomer" />
    </ApolloQuery>
    <ApolloQuery :query="require('../api/subscriptions/on_create_order.gql')" fetchPolicy="no-cache">
      <ApolloSubscribeToMore :document="require('../api/subscriptions/on_create_order.gql')" :updateQuery="onCreateOrder" />
    </ApolloQuery>
    <!-- Vuetify 2 does not flip drawers on rtl by itself: drive the side. -->
    <v-navigation-drawer app fixed v-model="drawerState" :right="$vuetify.rtl" dense color="primary" :width="reportsRail ? 86 : 256">
      <!-- Slim icon rail while on the Reports landing / report pages under /reports -->
      <div v-if="reportsRail" class="d-flex flex-column align-center pt-6">
        <v-img :src="logoUrl" contain max-height="44" max-width="44" class="mb-8" />
        <v-btn icon dark class="mb-4" to="/reports" :aria-label="$t('reports.home.search')">
          <v-icon>mdi-magnify</v-icon>
        </v-btn>
        <v-btn icon dark to="/reports" :aria-label="$t('core.reports')">
          <v-icon>mdi-text-box-outline</v-icon>
        </v-btn>
      </div>
      <template v-else>
      <v-row justify="end" v-if="$vuetify.breakpoint.mdAndDown" class="pe-5">
        <v-icon class="mt-5" @click="drawerState = false" color="dark">mdi-close</v-icon>
      </v-row>
      <v-row justify="center" class="tw-mt-6">
        <v-col cols="auto">
          <v-img :src="logoUrl" contain position="" max-height="80" max-width="120" />
        </v-col>
      </v-row>
      <v-list class="mt-lg-14 pb-lg-16 pe-5">
        <div class="mt-10 mt-lg-0">
          <div v-for="item in accessableItems[tab]" :key="item.key || item.route">
            <v-list-group class="mt-n2" v-if="item.elem && item.elem.length > 0">
              <template v-slot:activator>
                <v-list-item-icon>
                  <font-awesome-icon
                    class="mt-1 light--text font-weight-bold"
                    v-bind:class="{
                      'dark--text': $route.path === item.route,
                    }"
                    :icon="['fas', item.icon]"
                  ></font-awesome-icon>
                </v-list-item-icon>
                <v-list-item-content class="ms-n4">
                  <v-list-item-title
                    class="light--text font-weight-bold text-body-2"
                    v-bind:class="{
                      'dark--text': $route.path === item.route,
                    }"
                    >{{ item.text }}</v-list-item-title
                  >
                </v-list-item-content>
              </template>

              <v-list-item :to="obj.route" v-for="obj in item.elem" :key="obj.key || obj.route" dense color="light">
                <v-list-item-icon>
                  <font-awesome-icon
                    class="mt-1 ms-4 light--text font-weight-bold"
                    v-bind:class="{
                      'dark--text': $route.path === obj.route,
                    }"
                    :icon="['fas', obj.icon]"
                  ></font-awesome-icon>
                </v-list-item-icon>
                <v-list-item-title
                  class="light--text font-weight-bold ms-n2"
                  v-bind:class="{
                    'dark--text': $route.path === obj.route,
                  }"
                  >{{ obj.text }}
                </v-list-item-title>
              </v-list-item>
            </v-list-group>

            <v-list-item v-else router :to="item.route" color="light" dense>
              <v-list-item-icon>
                <v-img v-if="item.key == 'core.dashboard'" :src="require('../../assets/dashboard-icon-white.svg')" contain class="mt-1 ms-n1" height="18" />
                <v-img v-if="$route.path === '/dashboard' && item.key == 'core.dashboard'" :src="require('../../assets/dashboard-icon.svg')" contain class="mt-1 ms-n6" height="18" />
                <v-img v-if="item.key == 'core.offers'" :src="require('../../assets/offers-icon.svg')" contain class="mt-1 ms-n1" height="18" />
                <v-img v-if="$route.path === '/offers' && item.key == 'core.offers'" :src="require('../../assets/offers-icon-change.svg')" contain class="mt-1 ms-n6" height="18" />
                <font-awesome-icon
                  v-if="item.key != 'core.dashboard' && item.key != 'core.offers'"
                  class="mt-1 light--text font-weight-bold"
                  v-bind:class="{
                    'dark--text': $route.path === item.route,
                  }"
                  :icon="['fas', item.icon]"
                ></font-awesome-icon>
              </v-list-item-icon>

              <v-list-item-content class="ms-n4">
                <v-list-item-title
                  class="light--text font-weight-bold"
                  v-bind:class="{
                    'dark--text': $route.path === item.route,
                  }"
                  >{{ item.text }}</v-list-item-title
                >
              </v-list-item-content>
            </v-list-item>
          </div>
        </div>
      </v-list>
      </template>
    </v-navigation-drawer>
    <v-app-bar app class="white premium-navbar" flat height="70">
      <v-btn icon @click="toggleDrawer()" class="me-3 nav-menu-btn">
        <v-icon color="grey darken-3">mdi-menu</v-icon>
      </v-btn>

      <v-btn-toggle group color="light" v-model="tab" mandatory v-if="$vuetify.breakpoint.smAndUp" class="premium-tabs-toggle">
        <v-btn
          v-if="showSalesItems"
          :key="tabItems[0].text"
          class="premium-tab-btn text-capitalize"
          @click="tab = tabItems[0].tabindex"
          >{{ tabItems[0].text.toLowerCase() }}</v-btn
        >
        <v-btn
          v-if="showOperationItems"
          :key="tabItems[1].text"
          class="premium-tab-btn text-capitalize"
          @click="tab = tabItems[1].tabindex"
          >{{ tabItems[1].text.toLowerCase() }}</v-btn
        >
        <v-btn
          v-if="showReportItems"
          :key="tabItems[2].text"
          class="premium-tab-btn text-capitalize"
          @click="selectReportsTab"
          >{{ tabItems[2].text.toLowerCase() }}</v-btn
        >
        <v-btn
          v-if="showSettingsItems"
          :key="tabItems[3].text"
          class="premium-tab-btn text-capitalize"
          @click="tab = tabItems[3].tabindex"
          >{{ tabItems[3].text.toLowerCase() }}</v-btn
        >
        <v-btn
          v-if="showDieticianItems"
          :key="tabItems[4].text"
          class="premium-tab-btn text-capitalize"
          @click="tab = tabItems[4].tabindex"
          >{{ tabItems[4].text.toLowerCase() }}</v-btn
        >
      </v-btn-toggle>
      <v-spacer></v-spacer>

      <v-tooltip bottom>
        <template v-slot:activator="{ on: onTooltip }">
          <v-btn icon class="nav-icon-btn me-2" v-on="onTooltip" @click="openSupportUs">
            <v-icon size="26" color="#1f2937">mdi-headset</v-icon>
          </v-btn>
        </template>
        <span>{{ $t('core.supportUs') }}</span>
      </v-tooltip>

      <!-- Export History: reports you started; the badge counts the ones still being prepared -->
      <v-tooltip v-if="canSeeExports" bottom>
        <template v-slot:activator="{ on: onTooltip }">
          <v-badge overlap color="warning" :content="exportsPending" :value="exportsPending > 0" class="me-2">
            <v-btn icon class="nav-icon-btn" :aria-label="$t('reports.statusPage.title')" v-on="onTooltip" @click="openExportHistory">
              <v-icon size="26" color="#1f2937">mdi-download</v-icon>
            </v-btn>
          </v-badge>
        </template>
        <span>{{ $t("reports.statusPage.title") }}</span>
      </v-tooltip>

      <v-menu transition="slide-x-transition" offset-y>
        <template v-slot:activator="{ on }">
          <v-badge overlap color="error" :content="notifications.length" :value="notifications.length > 0" class="me-2">
            <v-btn v-on="on" icon class="nav-icon-btn">
              <v-icon size="26" color="#1f2937">mdi-bell-outline</v-icon>
            </v-btn>
          </v-badge>
        </template>
        <v-list dense min-width="200" class="rounded-xl py-2">
          <template v-if="notifications.length">
            <v-list-item v-for="item in notifications" :key="item._id">
              <v-list-item-content class="pa-3">
                <v-list-item-title class="text-body-2 text-wrap"> {{ item.message }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
          <template v-else>
            <v-list-item>
              <v-list-item-content class="pa-3">
                <v-list-item-title class="text-body-2 text-wrap grey--text text-center">{{ $t('core.noNotifications') }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-list>
      </v-menu>

      <div @click="profileDrawer = true" class="premium-profile-btn d-flex align-center ps-2 pe-3 py-1 rounded-pill cursor-pointer ms-2">
        <v-avatar size="34" class="white--text font-weight-bold" :color="profileUser.photo ? 'transparent' : 'primary'">
          <v-img v-if="profileUser.photo" :src="getUserPhotoUrl(profileUser.photo)" alt="user" />
          <span v-else class="text-caption font-weight-bold">{{ initials }}</span>
        </v-avatar>
        <div class="ms-2 d-none d-sm-block text-start" style="line-height: 1.2;">
          <div class="text-body-2 font-weight-bold dark--text text-capitalize">
            {{ (firstName || lastName) ? `${firstName} ${lastName}` : role }}
          </div>
          <div class="text-caption grey--text font-weight-medium">
            {{ role || $t('core.administrator') }}
          </div>
        </div>
        <v-icon small class="ms-2 grey--text">mdi-chevron-down</v-icon>
      </div>

      <template v-slot:extension v-if="$vuetify.breakpoint.xs">
        <v-row justify="center">
          <v-btn-toggle tile group color="primary" v-model="tab" mandatory>
            <v-btn
              :width="$vuetify.breakpoint.smAndUp ? 120 : ''"
              v-if="showSalesItems"
              :key="tabItems[0].text"
              class="font-weight-bold text-body-2 text-capitalize"
              @click="tab = tabItems[0].tabindex"
              >{{ tabItems[0].text }}</v-btn
            >
            <v-btn
              :width="$vuetify.breakpoint.smAndUp ? 120 : ''"
              v-if="showOperationItems"
              :key="tabItems[1].text"
              class="font-weight-bold text-body-2 text-capitalize"
              @click="tab = tabItems[1].tabindex"
              >{{ tabItems[1].text }}</v-btn
            >
            <v-btn
              :width="$vuetify.breakpoint.smAndUp ? 120 : ''"
              v-if="showReportItems"
              :key="tabItems[2].text"
              class="font-weight-bold text-body-2 text-capitalize"
              @click="selectReportsTab"
              >{{ tabItems[2].text }}</v-btn
            >
            <v-btn
              :width="$vuetify.breakpoint.smAndUp ? 120 : ''"
              v-if="showSettingsItems"
              :key="tabItems[3].text"
              class="font-weight-bold text-body-2 text-capitalize"
              @click="tab = tabItems[3].tabindex"
              >{{ tabItems[3].text }}</v-btn
            >
            <v-btn
              :width="$vuetify.breakpoint.smAndUp ? 120 : ''"
              v-if="showDieticianItems"
              :key="tabItems[4].text"
              class="font-weight-bold text-body-2 text-capitalize"
              @click="tab = tabItems[4].tabindex"
              >{{ tabItems[4].text }}</v-btn
            >
          </v-btn-toggle>
        </v-row>
      </template>
    </v-app-bar>

    <!-- Slide-out Profile Drawer (Mockup design matching first image) -->
    <v-navigation-drawer
      v-model="profileDrawer"
      :right="!$vuetify.rtl"
      temporary
      fixed
      width="420"
      color="primary"
      dark
      class="profile-drawer pa-8"
      style="z-index: 1000;"
    >
      <v-row no-gutters align="center" class="mb-8">
        <v-avatar size="68" color="teal darken-4" class="mr-4 elevation-1 font-weight-bold white--text text-h5">
          {{ initials }}
        </v-avatar>
        <div>
          <h3 class="text-h5 font-weight-bold white--text mb-1">{{ $t('core.profile') }}</h3>
          <span class="text-subtitle-2 grey--text text--lighten-2">{{ $t('core.manageYourAccountAndPreferences') }}</span>
        </div>
        <v-spacer></v-spacer>
        <v-btn icon color="white" @click="profileDrawer = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-row>

      <v-row no-gutters align="center" class="mb-6 justify-space-between" style="width: 100%;">
        <v-btn depressed class="profile-drawer-btn font-weight-bold text-subtitle-1 text-capitalize px-4 rounded-lg" to="/profile-settings" @click="profileDrawer = false">
          <v-icon left size="20" class="me-1">mdi-account-circle-outline</v-icon>
          {{ $t('core.myAccount') }}
        </v-btn>
        <v-btn depressed class="profile-drawer-logout-btn font-weight-bold text-subtitle-1 text-capitalize px-4 rounded-lg" @click="logoutUser">
          <v-icon left size="20" class="me-1">mdi-logout</v-icon>
          {{ $t('core.logout') }}
        </v-btn>
      </v-row>

      <v-divider class="grey darken-3 mb-6"></v-divider>

      <div class="profile-fields-container mb-6">
        <v-row>
          <v-col cols="6" class="py-3">
            <div class="field-label-text text-caption grey--text text--lighten-2 font-weight-bold text-uppercase mb-1">{{ $t('common.firstName') }}</div>
            <div class="field-value-text white--text font-weight-medium text-body-1">{{ profileUser.firstnameEn || '-' }}</div>
          </v-col>
          <v-col cols="6" class="py-3">
            <div class="field-label-text text-caption grey--text text--lighten-2 font-weight-bold text-uppercase mb-1">{{ $t('common.lastName') }}</div>
            <div class="field-value-text white--text font-weight-medium text-body-1">{{ profileUser.lastnameEn || '-' }}</div>
          </v-col>
          
          <v-col cols="12" class="py-3">
            <div class="field-label-text text-caption grey--text text--lighten-2 font-weight-bold text-uppercase mb-1">{{ $t('settings.emailId') }}</div>
            <div class="field-value-text white--text font-weight-medium text-body-1 text-truncate">{{ profileUser.email || '-' }}</div>
          </v-col>

          <v-col cols="12" class="py-3">
            <div class="field-label-text text-caption grey--text text--lighten-2 font-weight-bold text-uppercase mb-1">{{ $t('dietitian.mobileNumber') }}</div>
            <div class="field-value-text white--text font-weight-medium text-body-1">{{ profileUser.phone || '-' }}</div>
          </v-col>

          <v-col cols="6" class="py-3" v-if="profileUser.companyName">
            <div class="field-label-text text-caption grey--text text--lighten-2 font-weight-bold text-uppercase mb-1">{{ $t('common.companyName') }}</div>
            <div class="field-value-text white--text font-weight-medium text-body-1 text-capitalize">{{ profileUser.companyName }}</div>
          </v-col>

          <v-col cols="6" class="py-3" v-if="profileUser.whatsappNumber">
            <div class="field-label-text text-caption grey--text text--lighten-2 font-weight-bold text-uppercase mb-1">{{ $t('settings.whatsappNumber') }}</div>
            <div class="field-value-text white--text font-weight-medium text-body-1">{{ profileUser.whatsappNumber }}</div>
          </v-col>

          <v-col cols="6" class="py-3" v-if="profileUser.country">
            <div class="field-label-text text-caption grey--text text--lighten-2 font-weight-bold text-uppercase mb-1">{{ $t('common.country') }}</div>
            <div class="field-value-text white--text font-weight-medium text-body-1">{{ profileUser.country }}</div>
          </v-col>
        </v-row>
      </div>

      <v-divider class="grey darken-3 mb-6"></v-divider>

      <!-- Language: saved on the user record, so it follows them to any browser -->
      <v-row no-gutters align="center" class="mb-6">
        <v-col cols="12">
          <div class="field-label-text text-caption grey--text text--lighten-2 font-weight-bold text-uppercase mb-2">
            {{ $t('language.language') }}
          </div>
          <LanguageSwitcher class="profile-drawer-language" />
        </v-col>
      </v-row>

      <v-divider class="grey darken-3 mb-6"></v-divider>

      <v-row no-gutters align="center" class="mb-4">
        <span class="white--text font-weight-bold text-h6">{{ $t('core.security') }}</span>
        <v-spacer></v-spacer>
        <span class="grey--text text--lighten-1 text-body-2 mr-2">{{ $t('core.show') }}</span>
        <v-switch
          v-model="showSecurityDetails"
          color="white"
          hide-details
          class="mt-0"
        ></v-switch>
      </v-row>

      <v-expand-transition>
        <div v-if="showSecurityDetails" class="rounded-lg pa-4 mt-2" style="background-color: rgba(0, 0, 0, 0.25) !important;">
          <div class="text-body-2 white--text mb-3">
            {{ $t('core.toChangeYourPasswordOrSecurity') }}
          </div>
          <v-btn block color="white" class="black--text font-weight-bold text-capitalize" to="/profile-settings" @click="profileDrawer = false">
            {{ $t('core.goToSecuritySettings') }}
          </v-btn>
        </div>
      </v-expand-transition>
    </v-navigation-drawer>

    <v-card width="50" height="50" color="light" v-show="false">
      <v-card-text class="mt-12">
        <audio src="@/assets/audio/notification.mp3" muted="true" controls id="player"></audio>
        <audio src="@/assets/audio/ordernotification.wav" muted="true" controls id="playerOrder"></audio>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { isAdmin, isManager, isDietitian } from "../../user/methods/helper.js";
import { getPrimaryLogoUrl } from "../../utils/brand-settings-loader";
import { entitlementsState, hasPlanBackend, lockedFeatureOf } from "../../utils/entitlements";
import LanguageSwitcher from "./LanguageSwitcher.vue";
export default {
  components: {
    LanguageSwitcher,
  },

  mounted() {
    if (this.canSeeExports) this.refreshExports();
    this.$root.$on("exports-started", this.onExportsStarted);
  },
  beforeDestroy() {
    this.$root.$off("exports-started", this.onExportsStarted);
    clearTimeout(this.exportsTimer);
  },
  created() {
    const isGallaboxEnabled = window.__brandSettings?.isGallaboxEnabled === 1;
    this.items.forEach(category => {
      if (Array.isArray(category)) {
        category.forEach(item => {
          if (item.key === "core.integration" && item.elem) {
            item.elem = item.elem.filter(subItem => {
              if (subItem.key === "core.gallaboxWhatsapp") {
                return isGallaboxEnabled;
              }
              return true;
            });
          }
        });
      }
    });

    this.tab = this.items.findIndex(item => item.route === this.$route.path);
    
    // Always pre-load first and last name from localStorage if available
    const doneUserStr = localStorage.getItem("DONE_USER");
    if (doneUserStr) {
      try {
        const data = JSON.parse(doneUserStr);
        this.firstName = data.firstnameEn;
        this.lastName = data.lastnameEn;
      } catch (e) {
        console.error(e);
      }
    }

    if (isAdmin()) {
      this.role = "Admin";
      this.showSalesItems = true;
      this.showOperationItems = true;
      this.showReportItems = true;
      this.showDieticianItems = false;
      this.showSettingsItems = true;
      // Admins get the full static list; drop the geo-only entries for tenants that
      // aren't on the geo location system (the permission-driven branch below gates
      // them inline instead).
      this.accessableItems = this.useGeoLocations()
        ? this.items
        : this.items.map((group) =>
            group.map((item) =>
              item.elem
                ? { ...item, elem: item.elem.filter((sub) => sub.route !== "/delivery-locations") }
                : item
            )
          );
    } else if (isManager() || isDietitian()) {
      this.showDieticianItems = false;
      //#region Sales
      if (this.hasRole(this.AdminUserPermissions.DASHBOARD_VIEW)) {
        this.showSalesItems = true;
        const data = this.items[0].find(x => x.key == "core.dashboard");
        this.accessableItems[0].push(data);
      }

      if (this.hasRole(this.AdminUserPermissions.CUSTOMER_VIEW) || this.hasRole(this.AdminUserPermissions.IN_ACTIVE_CUSTOMER_VIEW)) {
        this.showSalesItems = true;
        const data = this.items[0].find(x => x.key == "common.customers");
        if (data) {
          this.accessableItems[0].push(data);
        }
      }

      if (this.hasRole(this.AdminUserPermissions.SALES_ORDER_VIEW)) {
        this.showSalesItems = true;
        const data = this.items[0].find(x => x.key == "common.subscriptions");
        if (data) {
          this.accessableItems[0].push(data);
        }
        const dataAbandoned = this.items[0].find(x => x.key == "orders.abandonedCart");
        if (dataAbandoned) {
          this.accessableItems[0].push(dataAbandoned);
        }
      }

      if (this.hasRole(this.AdminUserPermissions.MEALS_RATING_VIEW)) {
        this.showSalesItems = true;
        const data = this.items[0].find(x => x.key == "core.mealsRating");
        this.accessableItems[0].push(data);
      }
      if (this.hasRole(this.AdminUserPermissions.SHOP_ORDER_VIEW)) {
        this.showSalesItems = true;
        const data = this.items[0].find(x => x.key == "common.shopping");
        this.accessableItems[0].push(data);
      }
      if (this.hasRole(this.AdminUserPermissions.PAYMENT_VIEW)) {
        this.showSalesItems = true;
        const data = this.items[0].find(x => x.key == "common.payment");
        this.accessableItems[0].push(data);
      }
      if (this.hasRole(this.AdminUserPermissions.REFUND_REPORT)) {
        this.showSalesItems = true;
        const data = this.items[0].find(x => x.key == "common.refund");
        this.accessableItems[0].push(data);
      }

      if (this.hasRole(this.AdminUserPermissions.PUSH_NOTIFICATION_VIEW)) {
        this.showSalesItems = true;
        const data = this.items[0].find(x => x.key == "core.pushNotification");
        this.accessableItems[0].push(data);
      }
      //#endregion
      //#region Operations
      let x = null;
      this.showSalesItems ? (x = 1) : (x = 0);

      const operationItems = [];

      // 1. Kitchen
      const kitchenSubItems = [];
      if (
        this.hasRole(this.AdminUserPermissions.STOCK_VIEW) ||
        this.hasRole(this.AdminUserPermissions.PURCHASE_VIEW) ||
        this.hasRole(this.AdminUserPermissions.ADJUST_STOCK_VIEW) ||
        this.hasRole(this.AdminUserPermissions.MASTER_DATA_VIEW) ||
        this.hasRole(this.AdminUserPermissions.MONTHLY_USAGE_VIEW) ||
        this.hasRole(this.AdminUserPermissions.MONTHLY_PURCHASE_VIEW) ||
        // without the plan's inventory the stock keys above read false; units, brands and
        // vendors (the ingredient master needs them) stay reachable through this entry
        (!this.$hasFeature("inventory") &&
          (this.hasRole(this.AdminUserPermissions.UNIT_STOCK_VIEW) ||
            this.hasRole(this.AdminUserPermissions.BRAND_STOCK_VIEW) ||
            this.hasRole(this.AdminUserPermissions.SUPPLIER_STOCK_VIEW)))
      ) {
        kitchenSubItems.push({ key: 'common.ingredients', text: this.$t('common.ingredients'), icon: "archive", route: "/stock/master_data" });
      }
      if (this.hasRole(this.AdminUserPermissions.MEAL_VIEW)) {
        kitchenSubItems.push({ key: 'core.recipeMenu', text: this.$t('core.recipeMenu'), icon: "utensils", route: "/menuitems" });
      }
      if (this.hasRole(this.AdminUserPermissions.MEALS_CATEGORY_VIEW)) {
        kitchenSubItems.push({ key: 'core.mealsCategory', text: this.$t('core.mealsCategory'), icon: "boxes", route: "/menucategory" });
      }
      if (this.hasRole(this.AdminUserPermissions.DIET_PLAN_VIEW)) {
        kitchenSubItems.push({ key: 'core.planCategory', text: this.$t('core.planCategory'), icon: "shopping-basket", route: "/dietplan" });
      }
      if (this.hasRole(this.AdminUserPermissions.PLAN_VIEW)) {
        kitchenSubItems.push({ key: 'common.plans', text: this.$t('common.plans'), icon: "box", route: "/plans" });
      }

      if (kitchenSubItems.length > 0) {
        this.showOperationItems = true;
        operationItems.push({
          key: 'core.kitchen', text: this.$t('core.kitchen'),
          icon: "utensils",
          elem: kitchenSubItems
        });
      }

      // 2. Online Shop
      const shopSubItems = [];
      if (this.hasRole(this.AdminUserPermissions.SHOP_PRODUCT_VIEW)) {
        shopSubItems.push({ key: 'core.products', text: this.$t('core.products'), icon: "boxes", route: "/products" });
      }

      if (shopSubItems.length > 0) {
        this.showOperationItems = true;
        operationItems.push({
          key: 'core.onlineShop', text: this.$t('core.onlineShop'),
          icon: "shopping-bag",
          elem: shopSubItems
        });
      }

      // 3. Clinic
      const clinicSubItems = [];
      if (this.hasRole(this.AdminUserPermissions.DIETITIAN_VIEW)) {
        clinicSubItems.push({ key: 'common.dietitian', text: this.$t('common.dietitian'), icon: "user-md", route: "/dieticians" });
      }
      if (this.hasRole(this.AdminUserPermissions.DIETITIAN_APPOINTMENT_VIEW)) {
        clinicSubItems.push({ key: 'core.dietitianAppointments', text: this.$t('core.dietitianAppointments'), icon: "calendar-alt", route: "/dietician_slot_appointment" });
      }
      if (isDietitian() && this.hasRole(this.AdminUserPermissions.DIETITIAN_PLAN_SUGGESTION)) {
        clinicSubItems.push({ key: 'core.suggestedPlans', text: this.$t('core.suggestedPlans'), icon: "box", route: "/dietician_plan_suggestion" });
      }

      if (clinicSubItems.length > 0) {
        this.showOperationItems = true;
        operationItems.push({
          key: 'core.clinic', text: this.$t('core.clinic'),
          icon: "user-md",
          elem: clinicSubItems
        });
      }

      // 4. Delivery
      const deliverySubItems = [];
      if (this.hasRole(this.AdminUserPermissions.LOCATION_VIEW)) {
        // /shifts keeps Shifts + Zones in both modes; Delivery Locations replaces its
        // Governorate/Area/Block tabs once the tenant is on the geo location system
        deliverySubItems.push({ key: 'core.location', text: this.$t('core.location'), icon: "map-marker-alt", route: "/shifts" });
        if (this.useGeoLocations()) {
          deliverySubItems.push({ text: "Delivery Locations", icon: "globe", route: "/delivery-locations" });
        }
      }
      if (this.hasRole(this.AdminUserPermissions.DRIVER_VIEW)) {
        deliverySubItems.push({ key: 'core.drivers', text: this.$t('core.drivers'), icon: "car", route: "/drivers" });
      }
      if (this.hasRole(this.AdminUserPermissions.CONTACT_VIEW)) {
        deliverySubItems.push({ key: 'core.contactMethods', text: this.$t('core.contactMethods'), icon: "user-cog", route: "/contact-method" });
      }

      if (deliverySubItems.length > 0) {
        this.showOperationItems = true;
        operationItems.push({
          key: 'core.delivery', text: this.$t('core.delivery'),
          icon: "truck",
          elem: deliverySubItems
        });
      }

      // 5. Promotions
      const promoSubItems = [];
      if (this.hasRole(this.AdminUserPermissions.REFERRAL_VIEW)) {
        promoSubItems.push({ key: 'core.referrals', text: this.$t('core.referrals'), icon: "wallet", route: "/referrals" });
      }
      if (this.hasRole(this.AdminUserPermissions.PROMO_CODE_VIEW)) {
        promoSubItems.push({ key: 'core.promocode', text: this.$t('core.promocode'), icon: "percentage", route: "/promocodes" });
      }
      if (this.hasRole(this.AdminUserPermissions.OFFER_VIEW)) {
        promoSubItems.push({ key: 'core.offers', text: this.$t('core.offers'), icon: "box-open", route: "/offers" });
      }
      if (this.hasRole(this.AdminUserPermissions.CUSTOMER_TAG_VIEW)) {
        promoSubItems.push({ key: 'core.customerTag', text: this.$t('core.customerTag'), icon: "user-tag", route: "/customertags" });
      }
      if (this.hasRole(this.AdminUserPermissions.MEAL_TAG_VIEW)) {
        promoSubItems.push({ key: 'core.mealsTag', text: this.$t('core.mealsTag'), icon: "tags", route: "/mealtags" });
      }

      if (promoSubItems.length > 0) {
        this.showOperationItems = true;
        operationItems.push({
          key: 'core.promotions', text: this.$t('core.promotions'),
          icon: "percentage",
          elem: promoSubItems
        });
      }

      // 6. Universal Pause
      if (this.hasRole(this.AdminUserPermissions.UNIVERSAL_PAUSE_VIEW)) {
        this.showOperationItems = true;
        operationItems.push({ key: 'core.universalPause', text: this.$t('core.universalPause'), icon: "pause", route: "/universal-pause" });
      }

      // 7. Plan Switch
      if (this.hasRole(this.AdminUserPermissions.PLAN_SWITCH_VIEW)) {
        this.showOperationItems = true;
        operationItems.push({ key: 'core.planSwitch', text: this.$t('core.planSwitch'), icon: "retweet", route: "/plan-switch" });
      }

      // 8. Users
      const userSubItems = [];
      if (this.hasRole(this.AdminUserPermissions.ADMIN_VIEW)) {
        userSubItems.push({ key: 'core.admins', text: this.$t('core.admins'), icon: "user-shield", route: "/admins" });
      }
      if (this.hasRole(this.AdminUserPermissions.MANAGER_VIEW)) {
        userSubItems.push({ key: 'core.staff', text: this.$t('core.staff'), icon: "briefcase", route: "/managers" });
      }

      if (userSubItems.length > 0) {
        this.showOperationItems = true;
        operationItems.push({
          key: 'core.users', text: this.$t('core.users'),
          icon: "users",
          route: "/user",
          elem: userSubItems
        });
      }

      // 9. Faq
      if (this.hasRole(this.AdminUserPermissions.FAQ_VIEW)) {
        this.showOperationItems = true;
        operationItems.push({ key: 'core.faq', text: this.$t('core.faq'), icon: "question", route: "/faq" });
      }

      this.accessableItems[x].push(...operationItems);
      //#endregion
      //#region Report
      let y = null;
      if (x != null && this.showOperationItems) {
        y = x + 1;
      }
      if (x != null && !this.showOperationItems) {
        y = x;
      }
      if (this.hasRole(this.AdminUserPermissions.ORDER_ITEM_VIEW) || this.hasRole(this.AdminUserPermissions.INGREDIENT_VIEW)) {
        this.showReportItems = true;
        const data = this.items[2].find(x => x.key == "core.orders");
        this.accessableItems[y].push(data);
      }
      if (this.hasRole(this.AdminUserPermissions.DELIVERY_REPORT_VIEW)) {
        this.showReportItems = true;
        const data = this.items[2].find(x => x.key == "core.delivery");
        this.accessableItems[y].push(data);
      }
      if (this.hasRole(this.AdminUserPermissions.SET_MENU_REPORT_VIEW)) {
        this.showReportItems = true;
        const data = this.items[2].find(x => x.key == "core.setmenuPlan");
        this.accessableItems[y].push(data);
      }
      if (this.hasRole(this.AdminUserPermissions.CUSTOMER_VIEW) || this.hasRole(this.AdminUserPermissions.CUSTOMER_WITHOUT_MEAL_VIEW)) {
        this.showReportItems = true;
        const reportsCustomersItem = this.items[2].find(x => x.key == "common.customers");
        if (reportsCustomersItem) {
          const genderReport = reportsCustomersItem.elem.find(x => x.key == "core.genderWiseReport");
          const ageReport = reportsCustomersItem.elem.find(x => x.key == "core.ageWiseReport");
          const noMealReport = reportsCustomersItem.elem.find(x => x.key == "core.customersWithoutMeal");

          const data = { ...reportsCustomersItem, elem: [] };
          if (this.hasRole(this.AdminUserPermissions.CUSTOMER_VIEW)) {
            if (genderReport) data.elem.push(genderReport);
            if (ageReport) data.elem.push(ageReport);
          }
          if (this.hasRole(this.AdminUserPermissions.CUSTOMER_WITHOUT_MEAL_VIEW)) {
            if (noMealReport) data.elem.push(noMealReport);
          }
          if (data.elem.length > 0) {
            this.accessableItems[y].push(data);
          }
        }
      }
      if (this.hasRole(this.AdminUserPermissions.SALES_REPORT_VIEW)) {
        this.showReportItems = true;
        const data = this.items[2].find(x => x.key == "core.sales");
        this.accessableItems[y].push(data);
      }
      if (this.hasRole(this.AdminUserPermissions.DRIVER_REPORT_VIEW)) {
        this.showReportItems = true;
        const data = this.items[2].find(x => x.key == "common.driver");
        this.accessableItems[y].push(data);
      }
      if (this.hasRole(this.AdminUserPermissions.PROMO_CODE_REPORT_VIEW)) {
        this.showReportItems = true;
        const data = this.items[2].find(x => x.key == "common.promoCode");
        this.accessableItems[y].push(data);
      }
      if (this.hasRole(this.AdminUserPermissions.PLAN_TRANSFER_LIST)) {
        this.showReportItems = true;
        const data = this.items[2].find(x => x.key == "core.transferReport");
        this.accessableItems[y].push(data);
      }
      if (this.hasRole(this.AdminUserPermissions.REFERRAL_VIEW)) {
        this.showReportItems = true;
        const data = this.items[2].find(x => x.key == "core.referralReport");
        this.accessableItems[y].push(data);
      }
      if (this.hasRole(this.AdminUserPermissions.PAUSED_MEALS_REPORT_VIEW)) {
        this.showReportItems = true;
        const data = this.items[2].find(x => x.key == "core.pausedNoMeals");
        this.accessableItems[y].push(data);
      }
      // Meal Order Count shares the order report's permission (ORDER_ITEM_VIEW).
      if (this.hasRole(this.AdminUserPermissions.ORDER_ITEM_VIEW)) {
        this.showReportItems = true;
        const data = this.items[2].find(x => x.key == "reports.mealOrderCountReport");
        this.accessableItems[y].push(data);
      }
      if (this.hasRole(this.AdminUserPermissions.MONTHLY_SALES_VIEW)) {
        this.showReportItems = true;
        const data = this.items[2].find(x => x.key == "core.monthlySales");
        this.accessableItems[y].push(data);
      }
      if (this.hasRole(this.AdminUserPermissions.DIETITIAN_APPOINTMENTS_REPORT)) {
        this.showReportItems = true;
        const data = this.items[2].find(x => x.key == "core.dietitianReport");
        this.accessableItems[y].push(data);
      }
      if (this.hasRole(this.AdminUserPermissions.EXPORT_STATUS_REPORT)) {
        this.showReportItems = true;
        const data = this.items[2].find(x => x.key == "core.reportStatus");
        this.accessableItems[y].push(data);
      }
      let z = null;
      if (y != null && this.showReportItems) {
        z = y + 1;
      }
      if (y != null && !this.showReportItems) {
        z = y;
      }
      this.reportsTabIndex = y;

      if (this.hasRole(this.AdminUserPermissions.SETTINGS_VIEW)) {
        this.showSettingsItems = true;
        const data = this.items[3];
        this.accessableItems[z].push(...data);
      }
      let d = null;
      if (z != null && this.showSettingsItems) {
        d = z + 1;
      }
      if (z != null && !this.showSettingsItems) {
        d = z;
      }
      if (isDietitian()) {
        this.showDieticianItems = true;
        const data = this.items[4];
        this.accessableItems[d].push(...data);
      }
    }
    else {
      this.showSalesItems = false;
      this.showOperationItems = false;
      this.showReportItems = false;
      this.showDieticianItems = false;
      this.showSettingsItems = false;
    }

    // Landing on any /reports page (refresh, deep link) highlights the Reports tab
    if (this.$route.path === "/reports" || this.$route.path.startsWith("/reports/")) {
      this.tab = this.reportsTabIndex;
    }

    this.applyPlanGate();
  },
  methods: {
    openExportHistory() {
      if (this.$route.name !== "ReportStatus") this.$router.push({ name: "ReportStatus" }).catch(() => {});
    },
    // A new export was started: check right away, then every 10 s while any is still being prepared (max ~15 min).
    onExportsStarted() {
      this.exportsPolls = 0;
      clearTimeout(this.exportsTimer);
      this.exportsTimer = setTimeout(this.refreshExports, 1500);
    },
    async refreshExports() {
      try {
        const { data } = await this.$apollo.query({ query: require("../../reports/api/excelReports.graphql"), variables: { limit: 30 }, fetchPolicy: "network-only" });
        this.exportsPending = ((data && data.excelReport) || []).filter(r => r.status === "EXPORTING").length;
      } catch (error) {
        this.exportsPending = 0;
        return;
      }
      clearTimeout(this.exportsTimer);
      if (this.exportsPending > 0 && this.exportsPolls < 90) {
        this.exportsPolls += 1;
        this.exportsTimer = setTimeout(this.refreshExports, 10000);
      }
    },
    selectReportsTab() {
      this.tab = this.reportsTabIndex;
      if (this.$route.path !== "/reports") this.$router.push("/reports");
    },
    /*
     * SaaS plan gate (SAAS-REVAMP/DESIGN.md §8.5): one pass over what either role branch built,
     * so admins — who skip every permission check — are covered too. Drops entries whose route
     * needs a plan feature the tenant lacks (route meta.feature), then groups and tabs left
     * empty. Wind-down pages (route meta.windDown, still reachable for existing records) are
     * hidden here too while their feature is off. Without an entitlements snapshot no feature
     * hides anything; My plan alone also waits for a SaaS backend that serves plans (a status
     * response carrying `entitlements`).
     */
    applyPlanGate() {
      const planBackend = hasPlanBackend();
      if (!entitlementsState.loaded && planBackend) return;
      const locked = route => {
        if (!route) return false;
        if (route === "/my-plan") return !planBackend;
        return entitlementsState.loaded && !!lockedFeatureOf(this.$router.resolve(route).route, { includeWindDown: true });
      };
      const keepOpen = entries =>
        entries.reduce((kept, item) => {
          if (!item) {
            kept.push(item);
          } else if (item.elem && item.elem.length) {
            const elem = item.elem.filter(sub => !locked(sub.route));
            if (elem.length) kept.push(elem.length === item.elem.length ? item : { ...item, elem });
          } else if (!locked(item.route)) {
            kept.push(item);
          }
          return kept;
        }, []);
      // The visible tabs own the leading slots of accessableItems, in this order (the slot
      // arithmetic above): a tab left with nothing is hidden and the later ones move up.
      const tabFlags = ["showSalesItems", "showOperationItems", "showReportItems", "showSettingsItems", "showDieticianItems"];
      const slots = [];
      let slot = 0;
      tabFlags.forEach(flag => {
        if (!this[flag]) return;
        const entries = keepOpen(this.accessableItems[slot++] || []);
        if (entries.length) slots.push(entries);
        else this[flag] = false;
      });
      while (slots.length < 5) slots.push([]);
      this.accessableItems = slots;
    },
    openSupportUs() {
      window.open("https://crm.bizosuite.com/portal", "_blank", "noopener,noreferrer");
    },
    onCreateCustomer(previousResult, { subscriptionData }) {
      if (subscriptionData.data.onCreateCustomer != null) {
        let firstName = "";
        let lastName = "";
        let id = subscriptionData.data.onCreateCustomer._id;
        if (subscriptionData.data.onCreateCustomer.user) {
          firstName = subscriptionData.data.onCreateCustomer.user.firstnameEn;
          lastName = subscriptionData.data.onCreateCustomer.user.lastnameEn;
        }
        if (this.notifications.filter(x => x.id == id).length == 0) {
          this.notifications.push({
            message: this.$t("core.registeredCustomerNotice", { name: firstName + " " + lastName }),
            id: id,
          });
          this.snackText = this.$t('core.newCustomerRegistered');
          const player = document.getElementById("player");
          player.play();
          setTimeout(() => {
            this.snackbar = true;
          }, 500);
        }
      }
    },
    onCreateOrder(previousResult, { subscriptionData }) {
      debugger;
      if (subscriptionData.data.onCreateOrder != null) {
        let id = subscriptionData.data.onCreateOrder._id;
        if (this.notifications.filter(x => x.id == id).length == 0) {
          this.notifications.push({
            message: this.$t("core.newOrderPlaced"),
            id: id,
          });
          const player = document.getElementById("playerOrder");
          this.snackText = this.$t('core.newOrderPlaced');
          player.play();
          setTimeout(() => {
            this.snackbar = true;
          }, 500);
        }
      }
    },

    toggleDrawer: function() {
      this.drawerState = !this.drawerState;
    },

    logoutUser() {
      const { onLogout } = require("@/vue-apollo.js");
      onLogout(this.$apollo.provider.defaultClient);
      localStorage.removeItem("DONE_USER");
      localStorage.removeItem("DONE_USER_ROLE");
      localStorage.removeItem("DONE_USER_PERMISSIONS");
      localStorage.removeItem("DONE_USER_ROLE_PERMISSIONS");
      this.profileDrawer = false;
      this.$router.replace({ path: "/" });
    },
    getUserPhotoUrl(photo) {
      if (!photo) return "";
      if (photo.startsWith("http://") || photo.startsWith("https://")) {
        return photo;
      }
      return this.imageUrl + photo;
    },
  },
  computed: {
    canSeeExports() {
      return this.hasRole(this.AdminUserPermissions.EXPORT_STATUS_REPORT);
    },
    // Slim rail only while the Reports tab is the active one; picking Sales/Operation/Settings
    // brings back that tab's normal sidebar even though the current page is still a report.
    reportsRail() {
      // Report Status (/report-status) is part of the Reports area too, so it gets the same rail
      const path = this.$route.path;
      const onReportsPage = path === "/reports" || path.startsWith("/reports/") || path === "/report-status";
      return onReportsPage && this.tab === this.reportsTabIndex;
    },
    logoUrl() {
      return getPrimaryLogoUrl(require('../../assets/signin-logo.png'));
    },
    initials() {
      const first = this.profileUser && this.profileUser.firstnameEn ? this.profileUser.firstnameEn.charAt(0) : "";
      const last = this.profileUser && this.profileUser.lastnameEn ? this.profileUser.lastnameEn.charAt(0) : "";
      return (first + last).toUpperCase() || "AA";
    },
  },
  apollo: {
    getUser() {
      return {
        query: require("../../settings/api/getUser.graphql"),
        result({ data }) {
          if (data && data.getUser) {
            this.profileUser = data.getUser;
          }
        },
      };
    },
  },
  data() {
    return {
      imageUrl: process.env.VUE_APP_BASE_URL,
      profileDrawer: false,
      showSecurityDetails: false,
      profileUser: {
        firstnameEn: "",
        lastnameEn: "",
        email: "",
        phone: "",
        companyName: "",
        whatsappNumber: "",
        country: "",
        photo: "",
      },
      snackbar: false,
      snackText: "",
      notifications: [],
      createCustomer: [],
      drawerState: null,
      role: "",
      showSalesItems: false,
      showOperationItems: false,
      showReportItems: false,
      showDieticianItems: false,
      showSettingsItems: false,
      tab: 0,
      reportsTabIndex: 2,
      exportsPending: 0,
      exportsPolls: 0,
      exportsTimer: null,
      firstName: "",
      lastName: "",
      tabItems: [
        { key: 'core.sales2', text: this.$t('core.sales2'), icon: "mdi-view-dashboard", tabindex: 0 },
        { key: 'core.operation', text: this.$t('core.operation'), icon: "mdi-scooter", tabindex: 1 },
        { key: 'core.reports', text: this.$t('core.reports'), icon: "mdi-account-circle", tabindex: 2 },
        { key: 'core.settings', text: this.$t('core.settings'), icon: "mdi-settings", tabindex: 3 },
        { key: 'core.dietitian', text: this.$t('core.dietitian'), icon: "mdi-settings", tabindex: 4 },
      ],
      dieticianItem: {
        key: 'core.appointments', text: this.$t('core.appointments'),
        icon: "calendar-alt",
        route: "/appointments",
      },
      accessableItems: [[], [], [], [], []],
      items: [
        //  SALES
        [
          {
            key: 'core.dashboard', text: this.$t('core.dashboard'),
            icon: "chart-bar",
            route: "/dashboard",
          },
          { key: 'common.customers', text: this.$t('common.customers'), icon: "user", route: "/customers" },
          { key: 'common.subscriptions', text: this.$t('common.subscriptions'), icon: "file-alt", route: "/salesorder" },
          { key: 'orders.abandonedCart', text: this.$t('orders.abandonedCart'), icon: "shopping-cart", route: "/abandonedcart" },
          { key: 'common.payment', text: this.$t('common.payment'),           icon: "credit-card",   route: "/accounts" },
          { key: 'common.refund', text: this.$t('common.refund'),            icon: "file-excel",    route: "/online-refund" },
          { key: 'core.mealsRating', text: this.$t('core.mealsRating'),      icon: "star-half-alt", route: "/rating" },
          { key: 'common.shopping', text: this.$t('common.shopping'),          icon: "shopping-bag",  route: "/shopping" },
          { key: 'core.pushNotification', text: this.$t('core.pushNotification'), icon: "bell",          route: "/notifications" },
          { key: 'core.scheduleNotification', text: this.$t('core.scheduleNotification'), icon: "bell",      route: "/schedule-notification" },
        ],

        //  OPERATION
        [
          {
            key: 'core.kitchen', text: this.$t('core.kitchen'),
            icon: "utensils",
            elem: [
              { key: 'common.ingredients', text: this.$t('common.ingredients'), icon: "archive", route: "/stock/master_data" },
              { key: 'core.recipeMenu', text: this.$t('core.recipeMenu'), icon: "utensils", route: "/menuitems" },
              { key: 'core.mealsCategory', text: this.$t('core.mealsCategory'), icon: "boxes", route: "/menucategory" },
              { key: 'core.planCategory', text: this.$t('core.planCategory'), icon: "shopping-basket", route: "/dietplan" },
              { key: 'common.plans', text: this.$t('common.plans'), icon: "box", route: "/plans" },
            ],
          },
          {
            key: 'core.onlineShop', text: this.$t('core.onlineShop'),
            icon: "shopping-bag",
            elem: [
              { key: 'core.products', text: this.$t('core.products'), icon: "boxes", route: "/products" },
            ],
          },
          {
            key: 'core.clinic', text: this.$t('core.clinic'),
            icon: "user-md",
            elem: [
              { key: 'common.dietitian', text: this.$t('common.dietitian'), icon: "user-md", route: "/dieticians" },
              { key: 'core.dietitianAppointments', text: this.$t('core.dietitianAppointments'), icon: "calendar-alt", route: "/dietician_slot_appointment" },
              { key: 'core.suggestedPlans', text: this.$t('core.suggestedPlans'), icon: "box", route: "/dietician_plan_suggestion" },
            ],
          },
          {
            key: 'core.delivery', text: this.$t('core.delivery'),
            icon: "truck",
            elem: [
              { key: 'core.location', text: this.$t('core.location'), icon: "map-marker-alt", route: "/shifts" },
              { text: "Delivery Locations", icon: "globe", route: "/delivery-locations" },
              { key: 'core.drivers', text: this.$t('core.drivers'), icon: "car", route: "/drivers" },
              { key: 'core.contactMethods', text: this.$t('core.contactMethods'), icon: "user-cog", route: "/contact-method" },
            ],
          },
          {
            key: 'core.promotions', text: this.$t('core.promotions'),
            icon: "percentage",
            elem: [
              { key: 'core.referrals', text: this.$t('core.referrals'), icon: "wallet", route: "/referrals" },
              { key: 'core.promocode', text: this.$t('core.promocode'), icon: "percentage", route: "/promocodes" },
              { key: 'core.offers', text: this.$t('core.offers'), icon: "box-open", route: "/offers" },
              { key: 'core.customerTag', text: this.$t('core.customerTag'), icon: "user-tag", route: "/customertags" },
              { key: 'core.mealsTag', text: this.$t('core.mealsTag'), icon: "tags", route: "/mealtags" },
            ],
          },
          { key: 'core.universalPause', text: this.$t('core.universalPause'), icon: "pause", route: "/universal-pause" },
          { key: 'core.planSwitch', text: this.$t('core.planSwitch'), icon: "retweet", route: "/plan-switch" },
          {
            key: 'core.users', text: this.$t('core.users'),
            icon: "users",
            route: "/user",
            elem: [
              { key: 'core.admins', text: this.$t('core.admins'), icon: "user-shield", route: "/admins" },
              { key: 'core.staff', text: this.$t('core.staff'), icon: "briefcase", route: "/managers" },
            ],
          },
          { key: 'core.faq', text: this.$t('core.faq'), icon: "question", route: "/faq" },
        ],

        //  REPORTS
        [
          { key: 'core.orders', text: this.$t('core.orders'),            icon: "shopping-bag", route: "/orders" },
          { key: 'core.delivery', text: this.$t('core.delivery'),          icon: "truck",        route: "/delivery" },
          {
            key: 'core.sales', text: this.$t('core.sales'),
            icon: "chart-line",
            elem: [
              { key: 'common.salesSummaryReport', text: this.$t('common.salesSummaryReport'), icon: "chart-line", route: "/sales" },
              { key: 'core.salesDetailedReport', text: this.$t('core.salesDetailedReport'), icon: "chart-bar", route: "/detailed-sales" },
            ],
          },
          { key: 'common.driver', text: this.$t('common.driver'),            icon: "car",          route: "/driver-report" },
          { key: 'core.setmenuPlan', text: this.$t('core.setmenuPlan'),      icon: "retweet",      route: "/set-menu-assign" },
          {
            key: 'common.customers', text: this.$t('common.customers'),
            icon: "user",
            elem: [
              { key: 'core.genderWiseReport', text: this.$t('core.genderWiseReport'), icon: "user", route: "/customer-gender-report" },
              { key: 'core.ageWiseReport', text: this.$t('core.ageWiseReport'),    icon: "user", route: "/customer-age-report" },
              { key: 'core.customersWithoutMeal', text: this.$t('core.customersWithoutMeal'),    icon: "user", route: "/customers-with-no-meals" },
            ],
          },
          { key: 'common.promoCode', text: this.$t('common.promoCode'),        icon: "percentage",   route: "/promocode-report" },
          { key: 'core.referralReport', text: this.$t('core.referralReport'),   icon: "percentage",   route: "/referral-report" },
          { key: 'core.transferReport', text: this.$t('core.transferReport'),   icon: "retweet",      route: "/plan-transfer-report" },
          { key: 'common.additionalPayment', text: this.$t('common.additionalPayment'),icon: "chart-line",   route: "/plan-payment-report" },
          { key: 'core.planSwitchHistory', text: this.$t('core.planSwitchHistory'),icon: "chart-line",  route: "/plan-switch-report" },
          { key: 'core.pausedNoMeals', text: this.$t('core.pausedNoMeals'),   icon: "user",         route: "/pausedmeals-report" },
          { key: 'reports.mealOrderCountReport', text: this.$t('reports.mealOrderCountReport'), icon: "chart-line", route: "/meal-order-count-report" },
          { key: 'core.monthlySales', text: this.$t('core.monthlySales'),     icon: "file-alt",     route: "/monthly-customer-sales" },
          { key: 'core.dietitianReport', text: this.$t('core.dietitianReport'),  icon: "user-md",      route: "/dietician-appointment-report" },
          { key: 'common.packages', text: this.$t('common.packages'),          icon: "box",          route: "/package-report" },
          { key: 'core.freezeReport', text: this.$t('core.freezeReport'),     icon: "user",         route: "/freeze-list" },
          { key: 'core.reportStatus', text: this.$t('core.reportStatus'),     icon: "file-excel",   route: "/report-status" },
          { key: 'core.contactUs', text: this.$t('core.contactUs'),        icon: "paperclip",    route: "/contactUs" },
        ],

        // SETTINGS
        [
          //  My Account
          {
            key: 'core.myAccount', text: this.$t('core.myAccount'),
            icon: "user-circle",
            elem: [
              { key: 'core.profile', text: this.$t('core.profile'),           icon: "user-cog",     route: "/profile-settings" },
              { key: 'core.whatsappSettings', text: this.$t('core.whatsappSettings'), icon: "comment-dots", route: "/whatsapp-settings" },
              { key: 'core.privacyPolicy', text: this.$t('core.privacyPolicy'), icon: "user-shield", route: "/privacy-policy-settings" },
            ],
          },

          //  System Configuration
          {
            key: 'core.systemConfiguration', text: this.$t('core.systemConfiguration'),
            icon: "cogs",
            elem: [
              { key: 'settings.configurations', text: this.$t('settings.configurations'),      icon: "cog",            route: "/configurations-settings" },
              { key: 'core.portionSettings', text: this.$t('core.portionSettings'),    icon: "utensils",       route: "/portion-settings" },
              { key: 'core.pdfTemplate', text: this.$t('core.pdfTemplate'), icon: "file-pdf", route: "/pdf-templates" },
              { key: 'core.termsAndConditions', text: this.$t('core.termsAndConditions'),icon: "file-signature", route: "/terms-and-conditions-settings" },
              { key: 'settings.tutorials', text: this.$t('settings.tutorials'),           icon: "puzzle-piece",   route: "/tutorials-settings" },
              { key: 'core.gatewayCharges', text: this.$t('core.gatewayCharges'),     icon: "chart-line",     route: "/gateway-charges" },
              { key: 'bills-and-payments.billsAndPayments', text: this.$t('bills-and-payments.billsAndPayments'),  icon: "file-invoice-dollar", route: "/bills-and-payments" },
              { key: 'saasPlan.myPlan', text: this.$t('saasPlan.myPlan'), icon: "gem", route: "/my-plan" },
            ],
          },

          { key: 'common.branch', text: this.$t('common.branch'),           icon: "building", route: "/branch-list" },
          {
            key: 'core.webSettings', text: this.$t('core.webSettings'),
            icon: "retweet",
            elem: [
              { key: 'core.homepage', text: this.$t('core.homepage'), icon: "box",   route: "/homepage-settings" },
              { key: 'core.article', text: this.$t('core.article'),  icon: "users", route: "/article" },
            ],
          },
          { key: 'core.systemAppearance', text: this.$t('core.systemAppearance'), icon: "desktop", route: "/system-appearance" },
          { key: 'core.configureMobileApp', text: this.$t('core.configureMobileApp'), icon: "mobile-alt", route: "/configure-mobile-app" },
          {
            key: 'core.integration', text: this.$t('core.integration'),
            icon: "plug",
            elem: [
              { key: 'core.paymentGateways', text: this.$t('core.paymentGateways'), icon: "credit-card", route: "/integration-payment" },
              { key: 'core.messaging', text: this.$t('core.messaging'),        icon: "comments",     route: "/integration-messaging" },
              { key: 'core.pushNotifications', text: this.$t('core.pushNotifications'), icon: "bell",       route: "/integration-push-notifications" },
              { key: 'core.gallaboxWhatsapp', text: this.$t('core.gallaboxWhatsapp'), icon: "whatsapp",   route: "/integration-gallabox-whatsapp" },
            ],
          },
        ],

        //DIETITIAN
        [
          { key: 'core.appointments', text: this.$t('core.appointments'), icon: "calendar-alt", route: "/appointments" },
        ],
      ],
    };
  },
};
</script>
<style>
.theme--light.v-btn--active:hover::before,
.theme--light.v-btn--active::before {
  opacity: 1 !important;
  color: var(--theme-primary) !important;
}

.theme--light.v-list-item--active:hover::before,
.theme--light.v-list-item--active::before {
  opacity: 1 !important;
}

.v-list-item--dense .v-list-item__title,
.v-list-item--dense .v-list-item__subtitle,
.v-list--dense .v-list-item .v-list-item__title,
.v-list--dense .v-list-item .v-list-item__subtitle {
  z-index: 1 !important;
}

svg:not(:root).svg-inline--fa {
  z-index: 1 !important;
}
</style>
<style scoped>
.theme--light.v-list-item--active:hover::before,
.theme--light.v-list-item--active::before {
  opacity: 1 !important;
}

.pp {
  font-size: 0.8125rem !important;
  font-weight: 900 !important;
}

.cursor-pointer {
  cursor: pointer;
}

.profile-drawer {
  background-color: var(--theme-primary) !important;
  color: var(--theme-primary-contrast, #ffffff) !important;
}

.profile-drawer >>> .v-navigation-drawer__content {
  color: var(--theme-primary-contrast, #ffffff) !important;
}

.profile-drawer .v-btn {
  text-transform: none;
}

.profile-drawer >>> .white--text {
  color: var(--theme-primary-contrast, #ffffff) !important;
}

.profile-drawer >>> .grey--text.text--lighten-2 {
  color: var(--theme-primary-contrast-muted, rgba(255, 255, 255, 0.75)) !important;
}

.profile-drawer >>> .v-divider {
  border-color: var(--theme-primary-contrast-border, rgba(255, 255, 255, 0.15)) !important;
}

.profile-drawer-btn {
  background-color: var(--theme-primary-contrast-border, rgba(255, 255, 255, 0.15)) !important;
  color: var(--theme-primary-contrast, #ffffff) !important;
}

.profile-drawer-logout-btn {
  background-color: var(--theme-primary-logout-bg, rgba(239, 68, 68, 0.2)) !important;
  color: var(--theme-primary-logout-text, #fca5a5) !important;
  border: 1px solid rgba(239, 68, 68, 0.15) !important;
}

.field-label-text {
  font-size: 0.75rem;
  letter-spacing: 0.05em;
  color: var(--theme-primary-contrast-muted, rgba(255, 255, 255, 0.75)) !important;
}

.field-value-text {
  font-size: 1.05rem;
  font-weight: 500;
  color: var(--theme-primary-contrast, #ffffff) !important;
}

.premium-navbar {
  border-bottom: 1px solid rgba(226, 232, 240, 0.7) !important;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.01), 0 2px 4px -1px rgba(0, 0, 0, 0.005) !important;
}

.nav-menu-btn {
  background-color: transparent !important;
}

.premium-tabs-toggle {
  background: transparent !important;
  border: none !important;
  gap: 8px;
}

.premium-tab-btn {
  font-size: 0.875rem !important;
  font-weight: 600 !important;
  letter-spacing: 0.01em !important;
  border-radius: 12px !important;
  height: 40px !important;
  min-width: 100px !important;
  text-transform: capitalize !important;
  color: #4b5563 !important;
  background-color: transparent !important;
  border: none !important;
  box-shadow: none !important;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.premium-tab-btn::before {
  display: none !important;
}

.premium-tab-btn:hover {
  color: var(--theme-primary) !important;
  background-color: rgba(1, 130, 148, 0.06) !important;
}

.premium-tab-btn.v-btn--active {
  color: #ffffff !important;
  background-color: var(--theme-primary) !important;
  font-weight: 700 !important;
  box-shadow: 0 4px 10px rgba(1, 130, 148, 0.15) !important;
}

.nav-icon-btn {
  width: 42px !important;
  height: 42px !important;
  border-radius: 12px !important;
  background: #f1f3f5 !important;
  transition: transform 0.2s ease, background-color 0.2s ease !important;
}
.nav-icon-btn:hover {
  transform: scale(1.05);
  background: #e5e7eb !important;
  background: color-mix(in srgb, var(--theme-primary, #0f3d4c) 14%, #fff) !important;
}
.nav-icon-btn:hover .v-icon {
  color: var(--theme-primary, #0f3d4c) !important;
}

.premium-profile-btn {
  border: 1px solid rgba(226, 232, 240, 0.8);
  background-color: #f8fafc;
  transition: all 0.2s ease !important;
}

.premium-profile-btn:hover {
  background-color: #f1f5f9;
  border-color: rgba(203, 213, 225, 1);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.02);
}
</style>